import { render, staticRenderFns } from "./UpcomingBuildingsPage.vue?vue&type=template&id=b3debfc0&scoped=true&"
import script from "./UpcomingBuildingsPage.vue?vue&type=script&lang=js&"
export * from "./UpcomingBuildingsPage.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingBuildingsPage.vue?vue&type=style&index=0&id=b3debfc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3debfc0",
  null
  
)

export default component.exports